import React, { Component } from 'react';
import ContentWrapper from '../../components/ContentWrapper';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Page from '@atlaskit/page';
import {
  loginAsync
} from '../../reducers/account';

import './Login.css';


class Login extends Component {

  state = {
    username: '',
    password: '',
  };

  onChangeUsername = (e) => { this.setState({username: `${e.target.value}`}); }
  onChangePassword = (e) => { this.setState({password: `${e.target.value}`}); }

  logIn = (e) => {
    e.preventDefault();
    this.props.loginAsync(this.state.username, this.state.password);
  }

  componentWillMount = () => {
  }

  render() {

    if(this.props.loggedIn) {
      this.props.goToApp();
    }

    return (
      <Page>
        <ContentWrapper>
          <div id="login">
            <div className="container" style={{marginTop: '-100px'}}>
              <div className="row">
                <div className="col-sm-8 col-md-6 offset-md-3 offset-sm-2 col-lg-4 offset-lg-4">
                  <h1 className="text-center login-title">Login to continue to Compass CMS</h1>
                  <div className="account-wall">
                    <div className="text-center">
                      <img src="/compass.png" alt="" width="120" />
                    </div>
                    <form onSubmit={this.logIn} className="form-signin">
                      {this.props.message &&
                        <div className="alert alert-danger" role="alert" style={{marginBottom: '20px'}}>
                          {this.props.message}
                        </div>
                      }
                      <input type="text" className="form-control" placeholder="Username" onChange={this.onChangeUsername} value={this.state.username} required autoFocus />
                      <input type="password" className="form-control" placeholder="Password" onChange={this.onChangePassword} value={this.state.password} required />
                      <button className="btn btn-lg btn-primary btn-block" type="submit" disabled={this.props.isLoggingIn}>Sign in</button>
                      <br/><span className="clearfix"></span>
                    </form>
                  </div>
                  <p className="footnote">Compass Wayfinder CMS V2.2.0</p>
                </div>
              </div>
            </div>
          </div>

        </ContentWrapper>
      </Page>
    )
  }
}


const mapStateToProps = state => ({
  loggedIn: state.account.loggedIn,
  isLoggingIn: state.account.isLoggingIn,
  message: state.account.message,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginAsync,
      goToApp: () => push('/')
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);


// WEBPACK FOOTER //
// ./src/modules/Login/Login.js